__turbopack_context__.v({
  "content": "gPqgAW_content",
  "detailsBody": "gPqgAW_detailsBody",
  "fieldContent": "gPqgAW_fieldContent",
  "fieldIcon": "gPqgAW_fieldIcon",
  "fieldLabel": "gPqgAW_fieldLabel",
  "fieldValue": "gPqgAW_fieldValue",
  "footer": "gPqgAW_footer",
  "footerActions": "gPqgAW_footerActions",
  "footerButton": "gPqgAW_footerButton",
  "iconDataField": "gPqgAW_iconDataField",
  "left": "gPqgAW_left",
  "orderSummary": "gPqgAW_orderSummary",
  "right": "gPqgAW_right",
});
